import React from "react";
import { useSelector, useStore } from "react-redux";
import PathLine from "@/components/layer/PathLine";

function NavigateLayer() {
  const { select } = useStore();
  const passage = useSelector(select.layer.selectCurrentLayer);
  if (!passage || !passage.geojson) return null;
  return (
    <PathLine
      key={`path-line-${passage.added}`}
      feature={passage.geojson}
      type={passage.type}
    />
  );
}

export default NavigateLayer;
